import React from "react";
import Highlighter from "react-highlight-words";
import { SearchOutlined } from "@ant-design/icons";

// Components
import {
    Button, Input, Space
} from "antd";

// eslint-disable-next-line import/prefer-default-export
export const getColumnSearchProps = ({
    colname, searchInput = null, filterObj, setFilterObj, handleSearch, handleReset
}) => ({
    filterDropdown: ({
        setSelectedKeys, selectedKeys, confirm, clearFilters
    }) => (
        <div style={{ padding: 8 }}>
            <Input
                ref={(node) => {
                    // eslint-disable-next-line no-param-reassign
                    searchInput = node;
                }}
                placeholder={`Search ${colname}`}
                value={selectedKeys[0]}
                onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                onPressEnter={() => handleSearch(selectedKeys, confirm, colname)}
                style={{ marginBottom: 8, display: "block" }}
            />
            <Space>
                <Button
                    type="primary"
                    onClick={() => handleSearch(selectedKeys, confirm, colname)}
                    icon={<SearchOutlined />}
                    size="small"
                    style={{ width: 90 }}
                >
                    Search
                </Button>
                <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                    Reset
                </Button>
                <Button
                    type="link"
                    size="small"
                    onClick={() => {
                        confirm({ closeDropdown: false });
                        setFilterObj({
                            searchText: selectedKeys[0],
                            searchedColumn: colname
                        });
                    }}
                >
                    Filter
                </Button>
            </Space>
        </div>
    ),
    filterIcon: (filtered) => <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />,
    onFilter: (value, record) => (record[colname]
        ? record[colname].toString().toLowerCase().includes(value.toLowerCase())
        : ""),
    onFilterDropdownVisibleChange: (visible) => {
        if (visible) {
            setTimeout(() => searchInput.select(), 100);
        }
    },
    render: (text) => (filterObj.searchedColumn === colname ? (
        <Highlighter
            highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
            searchWords={[filterObj.searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ""}
        />
    ) : (
        text
    ))
});
